/* eslint-disable @typescript-eslint/no-unused-vars */
import {ReactElement, useEffect, useState} from 'react';
import {
  MenuItem,
  OutlinedInput,
  InputLabel,
  CircularProgress,
  Typography,
  FormHelperText
} from '@mui/material';
import {
  SelectField,
  TextLabelWrapperComponentDiv,
  FormHelperTextP
} from './SelectInputStyle';

export interface SelectInputProps {
  field?: any;
  sx?: any;
  options: Array<any>;
  name: string;
  optionValueKey?: string;
  optionLabelKey?: string;
  enableDefaultOption?: boolean;
  errorMessage?: string;
  TextErrorMessage?: string;
  setValue?: string;
  onChange?: (e: any) => void;
  onChangeCallback?: any;
  label?: string;
  placeholder?: string;
  error?: any;
  value?: any;
  fullWidth?: any;
  disabled?: boolean;
  selectProps?: any;
  onOpenCallback?: any;
  variant?:string;
  focused?:boolean
  fetchOptionsFromOnOpenTrigger?: boolean;
  MenuProps?: any;
  classes?:any;
}

const SelectInput = (props: SelectInputProps): ReactElement => {
  const [currentValue, setCurrentValue] = useState<string>('');
  const [optionsList, setOptionsList] = useState<any>([]);

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const {
    options = [],
    optionValueKey = 'value',
    optionLabelKey = 'label',
    enableDefaultOption,
    placeholder,
    error,
    errorMessage,
    TextErrorMessage,
    value = '',
    label,
    fullWidth,
    disabled = false,
    onOpenCallback,
    onChangeCallback,
    fetchOptionsFromOnOpenTrigger,
    variant,
    focused,
    sx,
    ...rest
  } = props;
  const [optionss, setOPtions] = useState<any[]>([]);
  const generateSelectOptions = (data?: any) => {
    const data_list = data ?? options;
    setOPtions(data_list);
    const temp_list = data_list.map((option: any) => {
      return (
        <MenuItem key={option[optionValueKey]} value={option[optionValueKey]}>
          {option[optionLabelKey]}
        </MenuItem>
      );
    });
    setOptionsList(temp_list);
  };

  const handleCurrentValueChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMenuAnchor(null);
    setCurrentValue(event.target.value);
    if (onChangeCallback) {
      onChangeCallback(event);
    }
  };

  const handleOnOpen = async (e: any) => {
    setMenuAnchor(e.currentTarget);
    if (fetchOptionsFromOnOpenTrigger && options.length === 0) {
      setOptionsList(
        <MenuItem key={1} value={'loading'}>
          <span style={{marginRight: '5px'}}>{'...Loading'}</span>
          <CircularProgress size={24} />
        </MenuItem>
      );
      const temp_list = await onOpenCallback();
      generateSelectOptions(temp_list);
    }
  };

  useEffect(() => {
    if (!fetchOptionsFromOnOpenTrigger || options.length > 0) {
      generateSelectOptions();
    }
    setCurrentValue(value);
  }, [options]);

  return (
    <TextLabelWrapperComponentDiv>
      {label ? <InputLabel shrink={focused}>{label}</InputLabel> : ''}
      <SelectField
        {...props?.selectProps}
        anchorEl={menuAnchor}
        disabled={disabled}
        variant={variant||"outlined"}
        value={value}
        error={error}
        fullWidth={fullWidth}
        onOpen={e => handleOnOpen(e)}
        onChange={handleCurrentValueChange}
        {...rest}
        renderValue={(selected: any): any => {
          let searchObject;
          if (options.length > 0) {
            searchObject = options.find(item => {
              return item[optionValueKey] === selected;
            });
          } else if (optionss.length > 0) {
            searchObject = optionss.find(item => {
              return item[optionValueKey] === selected;
            });
          }
          if (searchObject) {
            return searchObject[optionLabelKey];
          }
          return placeholder || 'select';
        }}
        input={<OutlinedInput label={label} />}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0000003b',
            borderWidth: '1.8px'
          },
          ...sx
        }}
        // onChange={handleSelectChange}
      >
        <MenuItem value="" disabled={!!enableDefaultOption}>
          {placeholder || 'select'}
        </MenuItem>
        {optionsList}
      </SelectField>

      {error && <FormHelperTextP>{errorMessage}</FormHelperTextP>}
      {error && (
        <FormHelperText error>{TextErrorMessage}</FormHelperText>
      )}
    </TextLabelWrapperComponentDiv>
  );
};

export default SelectInput;
